'use strict';

require('./app.js');
require('./curations/companies.js');
require('./views/changeFocusCompanyItem.js');
require('./views/changeFocusCompany.js');
